module.exports = __webpack_public_path__ + "static/media/star_badge.48d0b0b3.svg";